import React, { useRef } from "react";
  import ReactQuill from "react-quill";
  import "react-quill/dist/quill.snow.css";
  
  interface IFormRichTextEditorProps {
    label?: string;
    id: string;
    value?: string;
    required?: boolean;
    onChange: (id: string, value: string) => void;
    error?: string;
    className?: string; // Accept either "quill-editor" or "quill-editor-small"
    hint?: string;
    readOnly?: boolean;
    modules?: any;
  }
  
  function FormRichTextEditor({
    label,
    id,
    value,
    required,
    onChange,
    error,
    className,
    hint,
    readOnly,
    modules,
  }: IFormRichTextEditorProps) {
    const quillRef = useRef<ReactQuill>(null);
  
    return (
      <div className="form-rich-text-container">
        {label && <label htmlFor={id} className="form-label">
          {label}
          {required && <>*</>}
        </label>}
        <div className={`form-rich-input ${className || "quill-editor"}`}>
          <ReactQuill
            ref={quillRef}
            value={value || ""}
            onChange={(content) => onChange(id, content)}
            readOnly={readOnly || false}
            modules={
              modules !== undefined
                ? modules
                : {
                    toolbar: {
                      container: [
                        [{ header: [1, 2, 3, false] }],
                        ["bold", "italic", "underline", "strike"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link", "image"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    },
                  }
            }
            className="ql-editor-container"
          />
        </div>
        {hint && <div className="form-hint">{hint}</div>}
        {error && <div className="form-error">{error}</div>}
      </div>
    );
  }
  
  export default FormRichTextEditor;